export const buildSortIndexMap = (sortedIds: string[]): Map<string, number> => {
  const map = new Map<string, number>();
  sortedIds.forEach((id, index) => {
    map.set(id, index);
  });
  return map;
};

export const getSortIndex = (
  sortIndexMap: Map<string, number>,
  vendorId: string,
): number => sortIndexMap.get(vendorId) ?? 0;
